<ul class="sidebar-menu nav flex-column" *ngIf="menu && menu.menuItems && menu.menuItems.length > 0">
    <li *ngFor="let menuItem of menu.menuItems" class="nav-item sidebar-item" [tooltip]="menuItem.tooltip" 
       placement="right" container="body" containerClass="tooltip-sidebar" triggers="hover">
        <a class="sidebar-link nav-link" [routerLink]="menuItem.routerLink" [routerLinkActive]="['active']">
            <i class="fa {{menuItem.icon}} sidebar-item-icon"></i>
        </a>
    </li>
</ul>